<template>
  <div class="detail-view pd-mdeium-horizontal">
    <!-- 审核记录 -->
    <div class="view-box" v-if="auditResult!=null">
      <div class="view-title">最近审核记录</div>
      <ul class="audit-result">
        <li>
          <span>审核结果：</span>
          <span class="red" v-if="auditResult.auditState==2">已入驻</span>
          <span class="red" v-if="auditResult.auditState==1">已驳回</span>
        </li>
        <li v-if="auditResult.reason!=''">
          <span>驳回理由：</span>
          <span class="black">{{auditResult.reason}}</span>
        </li>
        <li>
          <span>审核时间：</span>
          <span class="black">{{auditResult.auditTime|timeStampFormat}}</span>
        </li>
      </ul>
    </div>
    <!-- 店铺信息 -->
    <div class="view-box" v-if="shopDetail!=null">
      <div class="view-title">店铺信息</div>
      <div class="shop-detail">
        <ul>
          <li>
            <!-- logo -->
            <span>店铺LOGO：</span>
            <p class="pic-box" @click="showPicPopup(shopDetail.logo)">
              <img :src="shopDetail.logo" alt="店铺logo">
            </p>
          </li>
          <li>
            <!-- 店铺基本信息 -->
            <div class="sub-list-item">
              <p>
                <span>店铺名称：</span>
                <span>{{shopDetail.shopName}}</span>
              </p>
              <p>
                <span>创建时间：</span>
                <span>{{shopDetail.createAt|timeStampFormat}}</span>
              </p>
            </div>
            <div class="sub-list-item">
              <p>
                <span>店铺类型：</span>
                <span v-if="shopDetail.shopType==1">企业店铺</span>
                <span v-if="shopDetail.shopType==2">个体店铺</span>
              </p>
              <p>
                <span>经营者姓名：</span>
                <span>{{shopDetail.managerName}}</span>
              </p>
            </div>
            <div class="sub-list-item">
              <p>
                <span>所在城市：</span>
                <span>{{shopDetail.cityName}}</span>
              </p>
              <p>
                <span>经营者身份证号码：</span>
                <span>{{shopDetail.managerCard}}</span>
              </p>
            </div>
          </li>
          <li>
            <span>经营者身份证照片：</span>
            <p class="pic-box" @click="showPicPopup(shopDetail.cardFront)">
              <img :src="shopDetail.cardFront" alt>
            </p>
            <p class="pic-box" @click="showPicPopup(shopDetail.cardBack)">
              <img :src="shopDetail.cardBack" alt>
            </p>
            <p class="pic-box" @click="showPicPopup(shopDetail.cardTogerther)">
              <img :src="shopDetail.cardTogerther" alt>
            </p>
          </li>
          <li class="category">
            <!-- 经营类目 -->
            <span>经营类目：</span>
            <div class="category-list">
              <div
                class="category-item"
                v-for="(firstItem,firstIndex) in shopDetail.shopCatalogDtoList"
                :key="firstIndex"
              >
                <div class="first">{{firstItem.catagoryName}}</div>
                <div class="second">
                  <div
                    class="second-item"
                    v-for="(secItem,secIndex) in firstItem.childList"
                    :key="secIndex"
                  >
                    <p>{{secItem.catagoryName}}</p>
                    <span>
                      <i
                        v-for="(thirdItem,thirdIndex) in secItem.childList"
                        :key="thirdIndex"
                      >{{thirdItem.catagoryName}}</i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <!-- 联系电话 -->
            <span>店铺联系电话：</span>
            <span>{{shopDetail.telephone}}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 店铺资质 -->
    <div class="view-box" v-if="qualification!=null">
      <div class="view-title">店铺资质</div>
      <div class="shop-aptitude">
        <ul>
          <li>
            <!-- 店铺基本信息 -->
            <div class="sub-list-item" v-if="qualification.companyName!=''">
              <p>
                <span>公司名称：</span>
                <span>{{qualification.companyName}}</span>
              </p>
            </div>
            <div class="sub-list-item" v-if="qualification.legalPerson!=''">
              <p>
                <span>法人姓名：</span>
                <span>{{qualification.legalPerson}}</span>
              </p>
            </div>
            <div class="sub-list-item" v-if="qualification.idCardNo!=''">
              <p>
                <span>法人身份证号码：</span>
                <span>{{qualification.idCardNo}}</span>
              </p>
            </div>
          </li>
          <li v-if="qualification.idCardFrontPic!=''">
            <span>法人身份证照片：</span>
            <p class="pic-box" @click="showPicPopup(qualification.idCardFrontPic)">
              <img :src="qualification.idCardFrontPic" alt>
            </p>
            <p class="pic-box" @click="showPicPopup(qualification.idCardBackPic)">
              <img :src="qualification.idCardBackPic" alt>
            </p>
          </li>
          <li v-if="qualification.certificateNo!=''">
            <span>营业执照编号：</span>
            <span>{{qualification.certificateNo}}</span>
          </li>
          <li v-if="qualification.certificationPic!=''">
            <span>营业执照照片：</span>
            <p class="pic-box" @click="showPicPopup(qualification.certificationPic)">
              <img :src="qualification.certificationPic" alt>
            </p>
          </li>
          <li v-if="qualification.orgCode!=''">
            <span>组织机构代码：</span>
            <span>{{qualification.orgCode}}</span>
          </li>
          <li v-if="qualification.orgCertificatePic!=''">
            <span>组织机构代码证照片：</span>
            <p class="pic-box" @click="showPicPopup(qualification.orgCertificatePic)">
              <img :src="qualification.orgCertificatePic" alt>
            </p>
          </li>
          <li v-if="qualification.taxCertificateNo!=''">
            <span>税务登记证号：</span>
            <span>{{qualification.taxCertificateNo}}</span>
          </li>
          <li v-if="qualification.taxCertificatePic!=''">
            <span>税务登记证照片：</span>
            <p class="pic-box" @click="showPicPopup(qualification.taxCertificatePic)">
              <img :src="qualification.taxCertificatePic" alt>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 签约信息 -->
    <div class="view-box" v-if="settledInfo!=null">
      <div class="view-title">签约信息</div>
      <div class="shop-detail">
        <ul>
          <li>
            <span>入驻社区：</span>
            <span>{{settledCommunity}}</span>
          </li>
          <li class="category">
            <!-- 经营类目 -->
            <span>入驻类目：</span>
            <div class="category-list">
              <div
                class="category-item"
                v-for="(firstItem,firstIndex) in settledInfo.enterCatalogs"
                :key="firstIndex"
              >
                <div class="first">{{firstItem.catagoryName}}</div>
                <div class="second">
                  <div
                    class="second-item"
                    v-for="(secItem,secIndex) in firstItem.subCatalogs"
                    :key="secIndex"
                  >
                    <p>{{secItem.catagoryName}}</p>
                    <span>
                      <i
                        v-for="(thirdItem,thirdIndex) in secItem.subCatalogs"
                        :key="thirdIndex"
                      >{{thirdItem.catagoryName}}</i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
           <li>
            <span>物业分佣：</span>
            <span>{{(parseFloat(settledInfo.propertyScale)*100).toFixed(2)}}%</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 图片查看弹窗 -->
    <div class="pic-popup" v-if="showPopup" @click="showPicPopup('none')">
      <a href="javascript:;" class="close-btn">×</a>
      <div class="img-view">
        <img :src="imgView" alt>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      auditResult: null, //审核记录
      shopDetail: null, //基本信息
      qualification: null, //资质信息
      settledInfo: null, //签约信息
      settledCommunity: "", //入驻社区
      imgView: null, //弹窗大图
      showPopup: false, //显示弹窗
      auditResult: null, //审核记录
      shopDetail: null, //基本信息
      qualification: null, //资质信息
      settledInfo: null, //入驻(签约)信息
      tenementId: this.$store.state.user.tenementId //物业公司(租户)id
    };
  },
  props: {
    shopCode: String,
    enterId: Number,
    applyId: Number,
    auditable: Boolean
  },
  filters: {
    //时间戳转年月日格式化
    timeStampFormat(str) {
      let now = new Date(parseInt(str));
      const year = now.getFullYear();
      let month =
        (now.getMonth() + 1).toString().length == 1
          ? "0" + (now.getMonth() + 1).toString()
          : now.getMonth() + 1;
      let date =
        now.getDate().toString().length == 1
          ? "0" + now.getDate()
          : now.getDate();
      let seconds =
        now.getSeconds().toString().length == 1
          ? "0" + now.getSeconds()
          : now.getSeconds();
      let minute =
        now.getMinutes().toString().length == 1
          ? "0" + now.getMinutes()
          : now.getMinutes();
      let hour =
        now.getHours().toString().length == 1
          ? "0" + now.getHours()
          : now.getHours();
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        seconds
      );
    }
  },
  methods: {
    //显示大图
    showPicPopup(imgSrc) {
      this.showPopup = !this.showPopup;
      this.imgView = imgSrc == "none" ? null : imgSrc;
    },
    //获取店铺基本信息
    getShopDetail(shopCode) {
      axios
        .post("/dboss/ajax/shopDetail", {
          shopCode: shopCode
        })
        .then(res => {
          this.shopDetail = res.code == 200 ? res.data : null;
          // console.log("hahah");
          return;
        })
        .catch(e => e);
    },

    //获取店铺资质信息
    getShopQualification(shopCode) {
      axios
        .post("/dboss/ajax/shopQualification", {
          shopCode: shopCode
        })
        .then(res => {
          this.qualification = res.code == 200 ? res.data : null;
          // console.log(this.detailData);
          return;
        })
        .catch(e => e);
    },

    //获取店铺审核信息
    getShopAuditRecord(applyId, tenementId) {
      axios
        .post("/dboss/ajax/auditRecord", {
          enterId: applyId,
          tenementId: tenementId
        })
        .then(res => {
          this.auditResult = res.code == 200 ? res.data : null;
          return;
        })
        .catch(e => e);
    },

    //获取店铺入驻信息
    getShopAudit(enterId) {
      axios
        .post("/dboss/ajax/shopAudit", {
          enterId: enterId
        })
        .then(res => {
          this.settledInfo = res.code == 200 ? res.data : null;
          const communityLength = this.settledInfo.enterCommunitys.length;
          this.settledInfo.enterCommunitys.forEach((item, index) => {
            this.settledCommunity +=
              index == communityLength - 1
                ? item.communityName
                : item.communityName + ",";
          });
        })
        .catch(e => e);
    }
  },
  created() {
    // this.auditResult = this.detailData.auditResult;
    // this.shopDetail = this.detailData.shopDetail;
    // this.qualification = this.detailData.qualification;
    // this.settledInfo = this.detailData.settledInfo;
    this.getShopDetail(this.shopCode);
    this.getShopQualification(this.shopCode);
    this.getShopAudit(this.enterId);
    console.log(this.auditable);
    if (this.auditable == false) {
      this.getShopAuditRecord(this.applyId, this.tenementId);
    }
    // const communityLength = this.settledInfo.enterCommunitys.length;
    // console.log(this.settledInfo.enterCommunitys);
    // this.settledInfo.enterCommunitys.forEach((item, index) => {
    //   this.settledCommunity +=
    //     index == communityLength - 1
    //       ? item.communityName
    //       : item.communityName + ",";
    // });
  }
};
</script>
<style lang="less" module>
.detail-view {
  font-size: 14px;
  padding: 0 20px;
  .view-box {
    padding: 20px 0;
    border-bottom: 1px #ebf1f5 solid;
    .view-title {
      color: #354052;
      font-weight: bold;
    }
    .pic-box {
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #d8dfe5;
      position: relative;
      z-index: 1;
      overflow: hidden;
      margin-right: 10px;
      background: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:after {
        display: block;
        content: "";
        position: absolute;
        z-index: 2;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 24px;
        background: rgba(53, 64, 82, 0.5);
      }
      &:before {
        display: block;
        content: "查看";
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -20px;
        z-index: 3;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        background: url("//img1.jianyewy.com/58e3a660a552998cef8c66edd1357106.png")
          no-repeat;
        background-size: 13px;
        background-position: left center;
        padding-left: 16px;
      }
      img {
        width: 100px;
        max-height: 100px;
      }
    }
  }
  .view-box:last-child {
    border: 0;
  }
}

/* 审核记录 */
.audit-result {
  padding-top: 20px;
  line-height: 30px;
  li {
    display: flex;
    align-items: top;
    span:first-child {
      width: 145px;
      text-align: right;
      color: #9ba3af;
    }
    span:last-child {
      max-width: 900px;
    }
    .black {
      color: #354052;
    }
    .red {
      color: #e95e90;
    }
  }
}
/* 店铺信息 */
.shop-detail {
  padding-top: 20px;
  li {
    display: flex;
    align-items: top;
    margin-bottom: 10px;
    span:first-child {
      width: 145px;
      text-align: right;
      color: #9ba3af;
    }
    .sub-list-item {
      margin-right: 20px;
      line-height: 30px;
      width: 300px;
      span:last-child {
        width: 155px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-wrap: break-word;
      }
      p {
        display: flex;
        span:first-child {
          width: 145px;
          text-align: right;
        }
      }
    }
  }
  li.category {
    align-items: center;
    // padding-top: 28px;
    .category-list {
      // margin-top: -28px;
      .category-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .first {
          padding-right: 10px;
        }
        .second {
          display: flex;
          flex-direction: column;
          position: relative;
          &:after {
            display: block;
            content: "";
            width: 1px;
            background: #d8dfe5;
            left: 0;
            top: 20px;
            bottom: 20px;
            position: absolute;
            z-index: 1;
          }
          .second-item {
            display: flex;
            align-items: top;
            padding: 10px 0;
            position: relative;
            p {
              text-align: right;
              display: flex;
              align-items: top;
              position: relative;
              padding: 0 20px;
              &:before {
                display: block;
                content: "";
                width: 10px;
                height: 1px;
                background: #d8dfe5;
                position: absolute;
                left: 0;
                top: 9px;
              }
              &:after {
                display: block;
                content: "";
                width: 10px;
                height: 1px;
                background: #d8dfe5;
                position: absolute;
                right: 0;
                top: 9px;
              }
            }
            span {
              max-width: 700px;
              padding-left: 10px;
              color: #9ba3af;
              i {
                font-style: normal;
                margin-right: 5px;
                &:after {
                  display: inline-block;
                  content: " ,";
                }
              }
              i:last-child {
                &:after {
                  display: none;
                }
              }
            }
          }
          .second-item:last-child {
            &:after {
              display: block;
              content: "";
              width: 1px;
              height: 100%;
              background: #fff;
              left: 0;
              top: 20px;
              position: absolute;
              z-index: 2;
            }
          }
        }
      }
      .category-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
  li:last-child {
    margin-bottom: 0;
  }
}
/* 店铺资质 */
.shop-aptitude {
  padding-top: 20px;
  li {
    display: flex;
    align-items: top;
    margin-bottom: 10px;
    span:first-child {
      width: 145px;
      text-align: right;
      color: #9ba3af;
    }
    .sub-list-item {
      margin-right: 20px;
      line-height: 30px;
      span:last-child {
        width: 155px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-wrap: break-word;
      }
      p {
        display: flex;
        span:first-child {
          width: 145px;
          text-align: right;
        }
      }
    }
  }
  li:last-child {
    margin-bottom: 0;
  }
}
/* 图片弹窗 */
.pic-popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(53, 64, 82, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  .close-btn {
    position: absolute;
    right: 30px;
    top: 25px;
    width: 19pxd;
    font-size: 30px;
    line-height: 30px;
    color: #d8dfe5;
  }
  .img-view,
  img {
    width: 400px;
    max-height: 400px;
  }
}
</style>


